'use client';

import { createClient } from '@/lib/supabase/client';

export interface TechnicianSession {
  name: string;
  branch: string;
  clockedInAt: string;
}

const SESSION_KEY = 'fss_technician_session';

// ── localStorage (primary for session, fast) ──────────────────────────────────

export function getSession(): TechnicianSession | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as TechnicianSession;
  } catch {
    return null;
  }
}

export function saveSession(session: TechnicianSession): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  // Also persist to Supabase for cross-device visibility
  persistSessionToSupabase(session).catch(console.error);
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(SESSION_KEY);
}

// ── Supabase persistence (for reporting / real-time visibility) ───────────────

async function persistSessionToSupabase(session: TechnicianSession): Promise<void> {
  const supabase = createClient();
  await supabase.from('technician_sessions').insert({
    name: session.name,
    branch: session.branch,
    clocked_in_at: session.clockedInAt,
  });
}
